export default "__VITE_ASSET__b94fb843__"